import { render, staticRenderFns } from "./AddPrizes.vue?vue&type=template&id=6fe7ed0c"
import script from "./AddPrizes.vue?vue&type=script&lang=js"
export * from "./AddPrizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports